<script>
  import { goto } from "../../util";
  import { ux } from "../../store";
  import { pages } from "../../config";

  function backToDashboard() {
    goto(pages.dashboard.url);
  }
</script>

<dialog open>
  <article>
    <header>
      <a
        on:click={backToDashboard}
        href="#close"
        aria-label="Close"
        class="close"
      >
        &nbsp;
      </a>
    </header>
    <div>
      <hgroup>
        <h2>Now, Check Your Email</h2>
        <h4>
          Please click the link sent to {$ux.emailForSignIn} to finish authentication
        </h4>
      </hgroup>
      <!-- <progress /> -->
    </div>
  </article>
</dialog>

<style>
  article {
    width: 80vw;
    max-width: 700px;
  }
  article header {
    margin-bottom: 1em;
  }
  :global(button svg) {
    stroke-width: 1.6px;
  }
</style>
